import moment from 'moment';
//import "moment-timezone"

export const formatDate = (timestamp? : string|number|Date) => {
    if(!timestamp) {
        return "N/A"
    }
    if(typeof(timestamp)=="string") {
       timestamp = moment(timestamp,"YYYY-DD-MM HH:mm:ss.SSS").toDate().getTime();
    }

    return moment(timestamp).format("LLL");
}
export const fromNow = (timestamp? : number|Date) => {
    if(!timestamp) {
        return "N/A"
    }
    return moment(timestamp).utc().fromNow();
}
export const hasPassed = (d? : Date | number) =>  {
    if(!d) {
        d = 0;
    }
    let now = Date.now();
    let then;
    if(d instanceof Date) {
        then = d.getTime();
    } else {
        then = d;
    }
    return then < now;
}
